import * as ReactBootstrap from "react-bootstrap";
import React from "react";

export const FBB = ({questionId, onAnswer}) => {
    return (
        <ReactBootstrap.Form.Group key={questionId} controlId={questionId}>
            <ReactBootstrap.Form.Control
                onBlur={(e) => onAnswer(e.target.value)}
                as="textarea"
                rows={3}
            ></ReactBootstrap.Form.Control>
        </ReactBootstrap.Form.Group>
    )
}
